import { render } from "./LotInitialHold.vue?vue&type=template&id=6571cb78&scoped=true&ts=true&lang=pug"
import script from "./LotInitialHold.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotInitialHold.vue?vue&type=script&setup=true&lang=ts"

import "./LotInitialHold.vue?vue&type=style&index=0&id=6571cb78&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6571cb78"]])

export default __exports__